<section class="choose-flight" [class.choose-flight--inbound]="direction === Direction.INBOUND"
  [attr.aria-label]="'Escolha um voo de ' + direction.value">
  <header class="results-header" [class.results-header--error]="proceeded && form.controls[direction.name].errors?.required">
    <div class="results-heading">
      <div class="results-leg">
        <span class="results-leg__badge" [class.results-leg__badge--inbound]="direction === Direction.INBOUND">
          {{ direction.value }}
        </span>
        <h2 class="results-leg__title">Escolha o voo de {{ direction.value }}</h2>
      </div>
      <div class="results-summary">
        @if (direction === Direction.OUTBOUND) {
          <strong class="panel_route">{{ flightsFormData.airportOrigin }} <span aria-hidden="true">→</span> {{ flightsFormData.airportDestiny }}</strong>
          <span class="panel_day">{{ flightsFormData.dtDeparture | dateFormat: 'DD/MM/YYYY' }}</span>
        } @else {
          <strong class="panel_route">{{ flightsFormData.airportDestiny }} <span aria-hidden="true">→</span> {{ flightsFormData.airportOrigin }}</strong>
          <span class="panel_day">{{ flightsFormData.dtArrival | dateFormat: 'DD/MM/YYYY' }}</span>
        }
        <span class="results-count">{{ filteredFlights.length }} {{ filteredFlights.length === 1 ? 'voo' : 'voos' }}<span class="results-count__detail"> {{ filteredFlights.length === 1 ? 'encontrado' : 'encontrados' }}</span></span>
      </div>
      @if (proceeded && form.controls[direction.name].errors?.required) {
        <div class="results-header-error" role="alert">
          <span class="results-header-error__icon" aria-hidden="true">⚠️</span>
          <span class="results-header-error__text">Escolha o voo de {{ direction.value }} na lista abaixo para prosseguir.</span>
        </div>
      }
    </div>

    @if (searchCollapsed && direction === Direction.OUTBOUND) {
      <button class="results-edit" type="button" (click)="editSearch.emit()">
        Alterar busca <span aria-hidden="true">˅</span>
      </button>
    }

    <div class="results-controls">
      <div class="toggle-direct-flights">
        <span class="toggle-label">Voos com conexão</span>
        <mat-slide-toggle [checked]="!filterDirectOnly"
          (change)="onConnectingFlightsToggle($event.checked)"
          color="primary" aria-label="Incluir voos com conexão">
        </mat-slide-toggle>
      </div>
      <button #panelArrow class="collapse-flights_arrow" type="button"
        aria-label="Expandir ou recolher resultados" (click)="toggleCollapseFlights()"></button>
    </div>
  </header>

  <div #panelBody class="collapse-flights_body">
    <div class="flights">
      @for (option of filteredFlights; track option; let i = $index) {
        <article class="flight-container"
          [class.flight-container--selected]="checked(option)"
          [class.flight-container--viewing]="viewingDetails(option)"
          [class.flight-container--blocked]="isCheckboxDisabled(option)"
          [attr.aria-current]="checked(option) ? 'true' : null">
          <!-- Selection is the card itself (border + tint) and the "✓ Selecionado" control; no extra badge. -->
          <app-card-flight [flight]="option" [position]="i"
            [isMultiple]="option.flightSegments.length > 1">
            <mat-checkbox flightSelection class="flight-select-control" color="primary"
              (change)="selectCheckbox($event, option)"
              [checked]="checked(option)"
              [disabled]="isCheckboxDisabled(option)">
              <span class="selection-control__icon" aria-hidden="true"></span>
              @if (isCheckboxDisabled(option)) {
                Indisponível
              } @else if (checked(option)) {
                Selecionado
              } @else {
                Selecionar voo
              }
            </mat-checkbox>
          </app-card-flight>
        </article>
      }
    </div>
  </div>
</section>
